import React from "react";
import { container } from "./../../constants/styles";

function MyIQ() {
  return (
    <div className="min-h-screen bg-[#f2f3f5]">
      <div className={container}>
        {/* IQ Comparison Section */}
        <div className="py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {/* Coco Chanel */}
            <div className="text-center">
              <div className="text-6xl font-bold text-gray-800 mb-4">iq113</div>
              <h3 className="text-2xl font-semibold mb-6">Coco Chanel</h3>
              <div className="w-full h-64 bg-gray-200 rounded-lg flex items-center justify-center">
                <span className="text-gray-500">Coco Chanel Image</span>
              </div>
            </div>

            {/* You */}
            <div className="text-center">
              <div className="text-6xl font-bold text-blue-600 mb-4">iq???</div>
              <h3 className="text-2xl font-semibold mb-6">You</h3>
              <div className="w-full h-64 bg-gray-200 rounded-lg flex items-center justify-center">
                <span className="text-gray-500">Your Image</span>
              </div>
            </div>

            {/* Steve Jobs */}
            <div className="text-center">
              <div className="text-6xl font-bold text-gray-800 mb-4">iq160</div>
              <h3 className="text-2xl font-semibold mb-6">Steve Jobs</h3>
              <div className="w-full h-64 bg-gray-200 rounded-lg flex items-center justify-center">
                <span className="text-gray-500">Steve Jobs Image</span>
              </div>
            </div>
          </div>

          {/* Main CTA Section */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Your Report is Ready!
            </h1>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-600 mb-12">
              Reveal Your IQ Score Today!
            </h2>
          </div>

          {/* Trial Offer Section */}
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-16 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
              Try myIQ for 7 days
            </h3>
            
            <ul className="space-y-4 mb-8">
              <li className="flex items-start">
                <span className="text-green-500 mr-3">✓</span>
                <span>Get your precise IQ score with our scientifically-validated assessment</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-3">✓</span>
                <span>Know where you stand compared to the general population</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-3">✓</span>
                <span>Identify your cognitive strengths and weaknesses</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-3">✓</span>
                <span>Get a 7-day trial for just 1.00€. <strong>After trial, we'll charge 14.99€/2 weeks</strong> until you cancel.</span>
              </li>
            </ul>

            <div className="bg-yellow-100 border border-yellow-300 rounded-lg p-4 mb-6">
              <div className="flex items-center justify-between">
                <span className="font-semibold">Promo Code MYIQ-85 Applied</span>
                <span className="text-green-600 font-bold">You save 85%</span>
              </div>
            </div>

            <div className="text-center">
              <div className="text-lg mb-2">Total due today:</div>
              <div className="text-3xl font-bold">
                <span className="line-through text-gray-400">6.99€</span>
                <span className="text-green-600 ml-2">1.00€</span>
              </div>
            </div>
          </div>

          {/* Trust Section */}
          <div className="mb-16">
            <h3 className="text-3xl font-bold text-center text-gray-800 mb-12">
              Why You Can Trust myIQ
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <h4 className="text-xl font-bold text-gray-800 mb-4">Validated IQ Test</h4>
                <p className="text-gray-600">
                  Our assessment is based on the Stanford-Binet Intelligence Scale, the gold standard in IQ testing since 1916.
                </p>
              </div>
              
              <div className="text-center">
                <h4 className="text-xl font-bold text-gray-800 mb-4">Comprehensive Report</h4>
                <p className="text-gray-600">
                  Your personalized report is generated using the widely accepted Cattell-Horn-Carroll (CHC) theory of cognitive abilities.
                </p>
              </div>
              
              <div className="text-center">
                <h4 className="text-xl font-bold text-gray-800 mb-4">Neuroscience-Backed Training</h4>
                <p className="text-gray-600">
                  Our cognitive training programs are grounded in the latest neuroscience research, proven to enhance cognitive function and boost IQ scores.
                </p>
              </div>
            </div>
          </div>

          {/* Featured Section */}
          <div className="text-center mb-16">
            <h4 className="text-lg font-semibold text-gray-600 mb-4">
              myIQ HAS BEEN FEATURED IN
            </h4>
            <div className="flex justify-center space-x-8 text-gray-400">
              <span>Media Logo 1</span>
              <span>Media Logo 2</span>
              <span>Media Logo 3</span>
            </div>
          </div>

          {/* Personal IQ Report Section */}
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-16">
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Personal IQ Report</h3>
            
            <p className="text-gray-600 mb-6">
              Your results reveal fascinating insights into your cognitive strengths and untapped potential. With scores that place you among the top performers in key areas, your abilities in Logic and Pattern Recognition are truly exceptional:
            </p>
            
            <div className="bg-gray-100 p-6 rounded-lg mb-6">
              <p className="text-gray-600 italic">
                Your compatibility with Scorpio is a mystery. We have found many positive aspects but there are also pitfalls that can destroy your relationship and prevent you from starting a new one.
              </p>
            </div>
            
            <div className="text-center">
              <p className="text-lg font-semibold text-gray-800 mb-4">
                To read the full report, you need full access
              </p>
              <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
                Get Full Access
              </button>
            </div>
          </div>

          {/* Benefits Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <div>
              <h4 className="text-xl font-bold text-gray-800 mb-6">How you'll benefit</h4>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3">•</span>
                  <span>Outperform your peers and excel in competitive environments</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3">•</span>
                  <span>Open new career opportunities and achieve professional goals</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3">•</span>
                  <span>Make better decisions across all aspects of your life</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3">•</span>
                  <span>Boost your confidence and self-assurance to tackle new challenges</span>
                </li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-xl font-bold text-gray-800 mb-6">Learn How To</h4>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3">•</span>
                  <span>Solve complex problems with greater clarity and confidence</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3">•</span>
                  <span>Learn new skills faster and retain information more effectively</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3">•</span>
                  <span>Develop superior analytical thinking strategies</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3">•</span>
                  <span>Enhance memory recall for improved performance</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Testimonials Section */}
          <div className="mb-16">
            <h3 className="text-3xl font-bold text-center text-gray-800 mb-12">
              Results that inspire us
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl shadow-lg p-6 text-center">
                <div className="w-16 h-16 bg-gray-200 rounded-full mx-auto mb-4"></div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">Lucia García, 32</h4>
                <p className="text-gray-600 text-sm mb-4">Spain</p>
                <p className="text-gray-600">
                  Taking the MyIQ test was eye-opening! The personalized learning plan helped me improve my cognitive skills in just 3 months.
                </p>
              </div>
              
              <div className="bg-white rounded-xl shadow-lg p-6 text-center">
                <div className="w-16 h-16 bg-gray-200 rounded-full mx-auto mb-4"></div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">Alejandro Martínez, 54</h4>
                <p className="text-gray-600 text-sm mb-4">Spain</p>
                <p className="text-gray-600">
                  The detailed analysis of my cognitive strengths and weaknesses was incredibly accurate. My problem-solving abilities have improved dramatically!
                </p>
              </div>
              
              <div className="bg-white rounded-xl shadow-lg p-6 text-center">
                <div className="w-16 h-16 bg-gray-200 rounded-full mx-auto mb-4"></div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">Carlos López, 24</h4>
                <p className="text-gray-600 text-sm mb-4">Spain</p>
                <p className="text-gray-600">
                  I was skeptical at first, but the MyIQ learning plan was tailored perfectly to my needs. My academic performance has improved significantly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyIQ; 